import { apiInstagramChat } from '../http';
import ServiceCRUD from './ServiceCRUDNEWCHANNEL';

class ChatChannelsService extends ServiceCRUD {
  constructor() {
    super('configurations/channels');
  }
}

export default new ChatChannelsService();
